/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Hide backpack",
  "description": "Removes the backpack feature from the editor.",
  "userscripts": [
    {
      "url": "remove-backpack.js"
    }
  ],
  "userstyles": [
    {
      "url": "remove-backpack.css"
    }
  ],
  "tags": [
    "danger"
  ],
  "dynamicDisable": true,
  "enabledByDefault": false
};
export default manifest;
